import { Pipe, PipeTransform,Injectable } from '@angular/core';

@Pipe({
    name: 'fieldFilter',
    pure: false
})
@Injectable()
export class FieldFilterPipe implements PipeTransform {

//     transform(items: any[], args: any): any[] {
//       if (items) {
//           return items.filter(function (item) {
//               console.log(args);
//             //   for (let property in item) {
//             //       if (item[property] === null) {
//             //           continue;
//             //       }
//             //       if (typeof item[property] === 'object') {
//             //           if (traverse(item[property])) {
//             //               return true;
//             //           }
//             //       } else {
//             //           if (item[property].toString().toLowerCase().includes(args.toLowerCase())) {
//             //               return true;
//             //           }
//             //       }
//             //   }
//               return true;
//           });
//       }
//   }
transform(items: any, filed: string, value:string) {
    if (!value){
        return items;
    }else if(items){
//        console.log(filed,value)  
        return items.filter(item=>{return item[filed].toString().toLowerCase().includes(value.toLowerCase())})       
    }
   
  }

}
